import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerUserResendEmailEffects {
	put = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.resendEmail.resendEmail),
			switchMap((action) =>
				this.consumerService.resendInviteEmail(action.userIds).pipe(
					map(
						(stats) => ConsumerActions.resendEmail.resendEmailSuccess(),
						catchError((error) =>
							of(ConsumerActions.resendEmail.resendEmailFail(new FailState(error)))
						)
					)
				)
			)
		)
	);

	constructor(
		private consumerService: ConsumerService,
		private actions: Actions
	) {}
}
